const shipmentDirections = {
  incoming: 'incoming',
  outgoing: 'outgoing',
};

export { shipmentDirections };
